/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ConfirmedbasketsIdNopaymentmethodPutRequest model module.
 * @module model/ConfirmedbasketsIdNopaymentmethodPutRequest
 * @version 1.0.0
 */
class ConfirmedbasketsIdNopaymentmethodPutRequest {
    /**
     * Constructs a new <code>ConfirmedbasketsIdNopaymentmethodPutRequest</code>.
     * @alias module:model/ConfirmedbasketsIdNopaymentmethodPutRequest
     */
    constructor() { 
        
        ConfirmedbasketsIdNopaymentmethodPutRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ConfirmedbasketsIdNopaymentmethodPutRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ConfirmedbasketsIdNopaymentmethodPutRequest} obj Optional instance to populate.
     * @return {module:model/ConfirmedbasketsIdNopaymentmethodPutRequest} The populated <code>ConfirmedbasketsIdNopaymentmethodPutRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ConfirmedbasketsIdNopaymentmethodPutRequest();

            if (data.hasOwnProperty('paymentId')) {
                obj['paymentId'] = ApiClient.convertToType(data['paymentId'], 'Number');
            }
            if (data.hasOwnProperty('basketId')) {
                obj['basketId'] = ApiClient.convertToType(data['basketId'], 'Number');
            }
            if (data.hasOwnProperty('amount')) {
                obj['amount'] = ApiClient.convertToType(data['amount'], 'Number');
            }
            if (data.hasOwnProperty('currency')) {
                obj['currency'] = ApiClient.convertToType(data['currency'], 'String');
            }
            if (data.hasOwnProperty('gateway')) {
                obj['gateway'] = ApiClient.convertToType(data['gateway'], 'String');
            }
            if (data.hasOwnProperty('confirmedBasketHash')) {
                obj['confirmedBasketHash'] = ApiClient.convertToType(data['confirmedBasketHash'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ConfirmedbasketsIdNopaymentmethodPutRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ConfirmedbasketsIdNopaymentmethodPutRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
            throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
        }
        // ensure the json data is a string
        if (data['gateway'] && !(typeof data['gateway'] === 'string' || data['gateway'] instanceof String)) {
            throw new Error("Expected the field `gateway` to be a primitive type in the JSON string but got " + data['gateway']);
        }
        // ensure the json data is a string
        if (data['confirmedBasketHash'] && !(typeof data['confirmedBasketHash'] === 'string' || data['confirmedBasketHash'] instanceof String)) {
            throw new Error("Expected the field `confirmedBasketHash` to be a primitive type in the JSON string but got " + data['confirmedBasketHash']);
        }

        return true;
    }


}



/**
 * @member {Number} paymentId
 */
ConfirmedbasketsIdNopaymentmethodPutRequest.prototype['paymentId'] = undefined;

/**
 * @member {Number} basketId
 */
ConfirmedbasketsIdNopaymentmethodPutRequest.prototype['basketId'] = undefined;

/**
 * @member {Number} amount
 */
ConfirmedbasketsIdNopaymentmethodPutRequest.prototype['amount'] = undefined;

/**
 * @member {String} currency
 */
ConfirmedbasketsIdNopaymentmethodPutRequest.prototype['currency'] = undefined;

/**
 * @member {String} gateway
 */
ConfirmedbasketsIdNopaymentmethodPutRequest.prototype['gateway'] = undefined;

/**
 * @member {String} confirmedBasketHash
 */
ConfirmedbasketsIdNopaymentmethodPutRequest.prototype['confirmedBasketHash'] = undefined;






export default ConfirmedbasketsIdNopaymentmethodPutRequest;

